const suffixMap = {
  视频: require('@/assets/activity/video.svg'),
  ppt: require('@/assets/activity/ppt.svg'),
  excel: require('@/assets/activity/excel.svg'),
  word: require('@/assets/activity/doc.svg'),
  音频: require(`@/assets/activity/au.svg`),
  压缩包: require(`@/assets/activity/zip.svg`),
  其他: require(`@/assets/activity/other.svg`),
  pdf: require(`@/assets/activity/pdf.svg`),
  txt: require(`@/assets/activity/txt.svg`),
  md: require(`@/assets/activity/md.svg`),
}

export const getFileType = (suffix) => {
  suffix = suffix.toLowerCase()
  return suffixMap[suffix] || null
}

const middleMap = {
  视频: require(`@/assets/activity/videos.svg`),
  ppt: require(`@/assets/activity/ppts.svg`),
  excel: require(`@/assets/activity/excels.svg`),
  word: require(`@/assets/activity/words.svg`),
  音频: require(`@/assets/activity/aus.svg`),
  压缩包: require(`@/assets/activity/zips.svg`),
  其他: require(`@/assets/activity/others.svg`),
  pdf: require(`@/assets/activity/pdfs.svg`),
  txt: require(`@/assets/activity/txts.svg`),
  md: require(`@/assets/activity/mds.svg`),
}

export const getMinFileType = (suffix) => {
  suffix = suffix.toLowerCase()
  return middleMap[suffix] || null
}
